const icon = require('vue-svgicon');
icon.register({
    'cost': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path pid="0" d="M16 0C7.177 0 0 7.177 0 16s7.177 16 16 16 16-7.177 16-16S24.822 0 16 0zm0 29.423C8.599 29.423 2.577 23.402 2.577 16S8.598 2.577 16 2.577c7.401 0 13.423 6.021 13.423 13.423S23.401 29.423 16 29.423z"/><path pid="1" d="M17.21 14.781c-2.142-.857-3.049-1.436-3.049-2.469 0-.856.63-1.764 2.393-1.764 1.713 0 2.822.58 3.426.857l.68-2.318c-.806-.403-1.89-.781-3.477-.831V5.913h-2.066v2.469c-2.545.453-4.056 2.116-4.056 4.283 0 2.343 1.713 3.553 4.359 4.51 1.864.68 2.746 1.411 2.746 2.545 0 1.209-1.083 1.99-2.671 1.99-1.537 0-2.948-.529-3.93-1.108l-.68 2.368c.907.605 2.494 1.058 4.081 1.108v2.444h2.066v-2.595c2.771-.453 4.258-2.343 4.258-4.484 0-2.243-1.259-3.603-4.081-4.661z"/>`,
    },
});
